import { render } from "./AllPayments.vue?vue&type=template&id=655bac1a&scoped=true"
import script from "./AllPayments.vue?vue&type=script&lang=js"
export * from "./AllPayments.vue?vue&type=script&lang=js"

import "./AllPayments.vue?vue&type=style&index=0&id=655bac1a&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655bac1a"]])

export default __exports__